module.exports = __webpack_public_path__ + "static/media/logo-focus.c67967c3.svg";